/*
 * Copyright (c) Nexign, JSC, 2019-2021.
 */
/**
 * LinkBlock Service User Denied component
 *
 * @author Yakov Gushchin
 * @author Sergey Mysov
 * @version 1.23.0
 * @since 1.11.0
 */

import { FC, ReactElement } from 'react';

import { LinkBlock } from '../../../components/common';
import { ILinkProps } from '../../../components/common/LinkBlock/LinkBlock';
import ServiceUserDenied from './ServiceUserDenied';

type PartialBy<T, K extends keyof T> = Omit<T, K> & Partial<Pick<T, K>>

export interface ILinkBlockServiceUserDenied extends PartialBy<ILinkProps, 'children'> {
    renderChild?: (disabled: boolean) => ReactElement;
}
const LinkBlockServiceUserDenied: FC<ILinkBlockServiceUserDenied> = props => {
    const { children, renderChild, ...linkBlockProps } = props;

    return (
        <ServiceUserDenied {...linkBlockProps} renderComponent={disabled =>
            <LinkBlock {...linkBlockProps} disabled={disabled}>
                { renderChild ? renderChild(disabled) : children }
            </LinkBlock>
        } />
    );
};

LinkBlockServiceUserDenied.defaultProps = {
    className: '',
    url: '',
};

export default LinkBlockServiceUserDenied;
